import { Popup } from "react-map-gl"
import { CompanyMapPopupProps } from "./CompanyMapPopup.types"
import PlaceholderImage from '../../../../../../../assets/images/placeholder2.jpg'
import { ReactComponent as LocationPinIcon } from '../../../../../../../assets/vectors/location_on.svg';
import { ReactComponent as MailIcon } from '../../../../../../../assets/vectors/mail.svg';
import { ReactComponent as PhoneIcon } from '../../../../../../../assets/vectors/call.svg';
import { useEffect, useRef } from "react";
import { CURRENT_API } from "../../../../../../../utils/api/api";
import { formatPhoneNumber } from "../../../../../../../utils/helpers/numbers/formatPhoneNumber";

export default ({ selectedCompany, setSelectedCompany }: CompanyMapPopupProps) => {

  if (!(selectedCompany && selectedCompany.longitude && selectedCompany.latitude)) return null

  useEffect(() => {
    console.log('selectedCompany', selectedCompany)
  }, [selectedCompany])

  const popupRef = useRef<mapboxgl.Popup>(null);

  useEffect(() => {
    if (selectedCompany.longitude && selectedCompany.latitude) {
      console.log('popupRef.current?.isOpen()', popupRef.current?.isOpen())
      popupRef.current?.setLngLat({
        lat: selectedCompany.latitude,
        lng: selectedCompany.longitude
      })
    }
  }, [selectedCompany])

  return (
    <Popup 
      ref={popupRef} 
      key={selectedCompany.id_company + selectedCompany.longitude + selectedCompany.latitude}
      longitude={selectedCompany.longitude} 
      latitude={selectedCompany.latitude}
      anchor="bottom"
      onClose={(e) => {
        if (e.type === 'open') {
          setSelectedCompany(undefined)
        }
      }}
      closeOnClick={false}
      className='companies-map-popup'>
      <div className='flex-column'>
        <img
          src={selectedCompany.logo ? `${CURRENT_API}/users/logo?url=${selectedCompany.logo}` : PlaceholderImage}
          height={80}
          width="auto"
          style={{
            alignSelf: 'center',
            borderRadius: 12
          }}
        />
      </div>
      <div className='dashboard-companies__map-list-item-infos'>
        <span id='title'>{selectedCompany.name}</span>
        <div className='dashboard-companies__map-list-item-infos-location'>
          <LocationPinIcon />
          <span>{selectedCompany.address}, {selectedCompany.postalCode}, {selectedCompany.city}</span>
        </div>
        {selectedCompany.phone_owner &&
          <div className='dashboard-companies__map-list-item-infos-contact'>
            <PhoneIcon />
            <span>{formatPhoneNumber(selectedCompany.phone_owner)}</span>
          </div>
        }
        {selectedCompany.email_owner &&
          <div className='dashboard-companies__map-list-item-infos-contact'>
            <MailIcon />
            <span>{selectedCompany.email_owner}</span>
          </div>
        }
        {selectedCompany.description &&
          <p style={{ margin: 0, lineHeight: 1.2, color: 'var(--gray-9)' }}>
            {selectedCompany.description}
          </p>
        }
        <ul>
          {selectedCompany.NAF_list.split(',')?.map((domain, domainIndex) => (
            <li key={domainIndex}>{domain}</li>
          ))}
        </ul>
      </div>
    </Popup>
  )
}